import { SupplierList } from 'components/Suppliers/SupplierList';

export const HotelList: React.FC = () => <SupplierList />;
